import React from 'react'
import FormulationBomList from '../components/FormulationBomList'

const FormulationBom = () => {
	return <FormulationBomList />
}

export default FormulationBom
